<template>
  <div
    class="price-info price-info--price-line-through"
    :class="{
      'price-info--reduction': value.old
    }"
  >
    <div class="price-info__current">
      <span class="price-info__currency">
        {{ value.currency }}
      </span>
      <span
        class="price-info__value"
        v-if="value.old"
      >
        <span class="price-info__value-euro">{{ splitValue[0] }}</span>
        <span class="price-info__value-cent">{{ splitValue[1] }}</span>
      </span>
      <span
        class="price-info__value"
        v-else
      >
        <span class="price-info__value-euro">{{ splitValue[0] }}</span>
        <span class="price-info__value-cent">{{ splitValue[1] }}</span>
      </span>
      <sup
        v-if="showStar"
        class="price-info__asterisk"
      >
        *
      </sup>
    </div>
    <div class="price-info__unit">
      <span class="price-info__unit-text">
        {{ getUnitText() }}
      </span>
      <span class="price-info__unit-price">
        <span v-if="value.old">{{ value.oldUnitPrice }}</span>
        <span v-else>{{ value.unitPrice }}</span>
        <span v-if="value.unit">/{{ value.unit }}</span>
      </span>
    </div>
  </div>
</template>

<script lang="ts">
  import {Options, Prop, Vue} from 'vue-property-decorator';
  import type Price from '../../../bps/types/Price';

  @Options({
    name: 'price-info-oldest'
  })
  export default class PriceInfoOldest extends Vue {
    @Prop({required: true})
    value: Price;

    @Prop({default: false})
    showStar: boolean;

    @Prop()
    shippingInfoUrl: string;

    get splitValue() {
      const val = this.oldValue || this.value.currentValue;
      return val.split(/[:,]/);
    }

    get oldValue() {
      return this.value.old && this.value.old.replace(/[ €]/g, '') || null;
    }

    getUnitText() {
      let result = this.$t(`product.price.volumeUnit.${this.value.volumeUnit}`);
      if (this.value.unitPrice) {
        if (this.value.packageSize) {
          result += ' (' + this.value.packageSize + ')';
        }
        result += ',';
      }

      return result;
    }
  }
</script>
